import { Button, Card } from '@iwoca/orion';
import RiveComponent, { Alignment, Fit, Layout } from '@rive-app/react-canvas';

// @ts-ignore
import AllSetCelebrationRive from '../../../../assets/AllSetCelebrationRive.riv';
import PayLaterIllustration from '../../../../assets/PayLaterIllustration.svg';
import { LoadingScreen } from '../../../../components/LoadingScreen/LoadingScreen';
import { displayCurrency } from '../../../../utils/DisplayCurrency';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { redirectToMyAccount } from '../../../Signup/useRedirectToAccountPages';
import { useFormalOfferWithDuration } from '../../hooks/useFormalOfferWithDuration';

export const SecurityChecksSuccess = () => {
  const { formalOffer, loadingFormalOffer } = useFormalOfferWithDuration(3);
  if (loadingFormalOffer) {
    return <LoadingScreen />;
  }
  if (!formalOffer) {
    redirectToMyAccount();
  }

  const availableCredit = formalOffer?.available_credit;

  return (
    <Card className="mx-auto text-center">
      <div className="mx-auto w-[90%] overflow-hidden bg-white xs-480:w-full">
        <span className="mx-auto block h-[160px] w-[160px] text-center">
          <RiveComponent
            src={AllSetCelebrationRive}
            layout={
              new Layout({
                fit: Fit.Contain,
                alignment: Alignment.TopCenter,
              })
            }
          />
        </span>
        <div>
          <h5 className="mb-l text-center text-2xl font-bold">
            Your {availableCredit && displayCurrency(availableCredit) + ' '}
            spending limit is ready to use!
          </h5>
          <p className="mb-l text-center text-m font-reg">
            To use it just choose to Pay Later anywhere that offers iwocaPay to
            checkout in a few clicks
          </p>
          <img
            src={PayLaterIllustration}
            className="mb-m w-[70%] xs-480:w-full"
            alt="Pay Later Illustration"
          />
        </div>
        <WhiteLabelOverride componentType="button" disabled={false}>
          <Button
            className="mb-m w-[90%] xs-480:w-full"
            onClick={redirectToMyAccount}
          >
            Go to dashboard
          </Button>
        </WhiteLabelOverride>
      </div>
    </Card>
  );
};
